import React, { useEffect, useState, useContext, useCallback } from "react";
import axios from "axios";
import CustomTag from "../../../../../ui/CustomTag";
import CustomSelect from "../../../../../ui/CustomSelect";
import CustomModal from "../../../../../ui/CustomModal";
import AuthContext from "../../../../../contexts/AuthContext";
import toastOptions from "../../../../../assets/constants/toast";
import { PencilIcon, PlusIcon, XIcon } from "@phosphor-icons/react";
import { CircularProgress } from "@mui/material";
import { toast } from "react-toastify";

const CustomerInfo = ({ contact, onRefresh }) => {
    const { token } = useContext(AuthContext);

    const [availableDomains, setAvailableDomains] = useState([]);
    const [selectedDomains, setSelectedDomains] = useState([]);
    const [mappingLoading, setMappingLoading] = useState(false);
    const [showMappingModal, setShowMappingModal] = useState(false);

    const loadAvailableDomains = useCallback(async () => {
        if (!contact?.id) return;
        try {
            const response = await axios.get(`${process.env.REACT_APP_UPA_API_HOST}ovh/client/${contact.id}/domains`, { headers: { Authorization: `Bearer ${token}` } });
            const domains = response.data.allUnmappedDomains || [];

            const mappedDomainNames = contact.ovh?.domains?.map((d) => d.domainName) || [];
            const filteredDomains = domains.filter((domain) => !mappedDomainNames.includes(domain.domainName));

            setAvailableDomains(
                filteredDomains.map((domain) => ({
                    value: domain.domainName,
                    label: domain.domainName,
                    ...domain,
                }))
            );
        } catch (error) {
            console.error("Erreur chargement domaines:", error);
        }
    }, [contact?.id, contact.ovh?.domains, token]);

    useEffect(() => {
        if (contact) {
            loadAvailableDomains();
        }
    }, [contact, token, loadAvailableDomains]);

    const mapDomains = async () => {
        if (!selectedDomains || selectedDomains.length === 0 || !contact?.id) return;
        try {
            setMappingLoading(true);
            const mappingPromises = selectedDomains.map((domain) =>
                axios.post(`${process.env.REACT_APP_UPA_API_HOST}ovh/map-domain`, { domainName: domain.value, clientId: contact.id }, { headers: { Authorization: `Bearer ${token}` } })
            );
            await Promise.all(mappingPromises);
            toast.success(`${selectedDomains.length} domaine(s) mappé(s) avec succès`, toastOptions);
            setSelectedDomains([]);
            if (onRefresh) onRefresh();
            loadAvailableDomains();
            setShowMappingModal(false);
        } catch (error) {
            console.error("Erreur mapping:", error);
            toast.error("Erreur lors du mapping", toastOptions);
        } finally {
            setMappingLoading(false);
        }
    };

    const unmapDomain = async (domainName) => {
        try {
            setMappingLoading(true);
            await axios.delete(`${process.env.REACT_APP_UPA_API_HOST}ovh/unmap/${domainName}`, { headers: { Authorization: `Bearer ${token}` } });
            toast.success(`Domaine ${domainName} dé-mappé avec succès`, toastOptions);
            if (onRefresh) onRefresh();
            loadAvailableDomains();
        } catch (error) {
            console.error("Erreur unmapping:", error);
            toast.error("Erreur lors du dé-mapping", toastOptions);
        } finally {
            setMappingLoading(false);
        }
    };

    return (
        <div className="infos-container-wrapper">
            {/* <div className="infos-content-wrapper">
                <div className="infos-title-wrapper">
                    <p>Site Web</p>
                </div>
                <div className="infos-container">
                    <span className="infos-container-title mel">Date de mise en ligne :</span>
                    <CustomTag className={dateMEL === "Non renseigné" ? "deactivated" : ""} value={dateMEL || "Non renseigné"} />
                </div>
                <div className="infos-container">
                    <span className="infos-container-title cms">CMS :</span>
                    <CustomTag className={cms === "Non renseigné" ? "deactivated" : ""} value={cms || "Non renseigné"} />
                </div>
                {cms === "Wordpress" && (
                    <>
                        <div className="infos-container">
                            <span className="infos-container-title version">Version de PHP :</span>
                            <CustomTag className={phpVersion === "Non renseigné" ? "deactivated" : ""} value={phpVersion || "Non renseigné"} />
                        </div>
                        <div className="infos-container">
                            <span className="infos-container-title version">Version du CMS :</span>
                            <CustomTag className={cmsVersion ? "" : "deactivated"} value={cmsVersion ? `${cmsVersion} ${versionWordpress ? "(à jour)" : "(pas à jour)"}` : "Non renseigné"} />
                        </div>
                        <div className="infos-container">
                            <span className="infos-container-title builder">Builder utilisé :</span>
                            <CustomTag className={builder && builders.includes(builder) ? "purple" : "deactivated"} value={builder || "Non renseigné"} />
                        </div>
                    </>
                )}
                <div className="infos-container">
                    <span className="infos-container-title plugins">Plugins / Intégrations :</span>
                    {abonnementElfsightInstagram && <CustomTag className="pink" value="Elfsight Instagram" />}
                    {abonnementElfsightYoutube && <CustomTag className="pink" value="Elfsight YouTube" />}
                    {abonnementElfsightTiktok && <CustomTag className="pink" value="Elfsight TikTok" />}
                    {abonnementGoogleMaps && <CustomTag className="active" value="Google Maps" />}
                    {cms === "Wordpress" && pluginsWordpress.length > 0 && pluginsWordpress.map((plugin, index) => <CustomTag key={index} value={`${plugin.nomPlugin} - v${plugin.versionPlugin}`} />)}
                    {!abonnementElfsightInstagram && !abonnementElfsightYoutube && !abonnementElfsightTiktok && !abonnementGoogleMaps && (!pluginsWordpress || pluginsWordpress.length === 0) && (
                        <CustomTag className="deactivated" value="Aucun" />
                    )}
                </div>
                <div className="infos-container">
                    <span className="infos-container-title traduction">Traduction :</span>
                    <CustomTag className={traductionInfos === "Aucun" || traductionInfos === "Non renseigné" ? "deactivated" : ""} value={traductionInfos || "Non renseigné"} />
                </div>
                <div className="infos-container">
                    <span className="infos-container-title languages">Langues :</span>
                    {langues.length > 0 ? langues.map((langue, index) => <CustomTag key={index} value={langue} />) : <CustomTag value="Français" />}
                </div>
            </div>
            <div className="infos-content-wrapper">
                <div className="infos-title-wrapper">
                    <p>Web Services</p>
                </div>
                <div className="infos-container">
                    <span className="infos-container-title moteur">Moteur de réservation :</span>
                    <CustomTag className={engineType ? "" : "deactivated"} value={engineType || "Non renseigné"} />
                </div>
                <div className="infos-container">
                    <span className="infos-container-title lien-moteur">Lien du moteur :</span>
                    <CustomTag className={engineUrl ? "" : "deactivated"} value={engineUrl || "Non renseigné"} />
                </div>
                <div className="infos-container">
                    <span className="infos-container-title comparateur">Comparateur de prix :</span>
                    <CustomTag className={subscriptionPriceComparison ? "active" : "deactivated"} value={subscriptionPriceComparison ? "Oui" : "Non"} />
                </div>
                <div className="infos-container">
                    <span className="infos-container-title google-analytics">Widget :</span>
                    <CustomTag className={subscriptionWidget ? "active" : "deactivated"} value={subscriptionWidget ? "Oui" : "Non"} />
                </div>
                <div className="infos-container">
                    <span className="infos-container-title api">API :</span>
                    <CustomTag className={hasAPI ? "active" : "deactivated"} value={apiStatus} />
                </div>
                <div className="infos-container">
                    <span className="infos-container-title google-ads">Google Ads :</span>
                    <CustomTag className={subscriptionAds ? "active" : "deactivated"} value={subscriptionAds ? "Oui" : "Non"} />
                </div>
                <div className="infos-container">
                    <span className="infos-container-title google-analytics">Google Analytics :</span>
                    <CustomTag className={subscriptionAds ? "active" : "deactivated"} value={subscriptionAds ? "Oui" : "Non"} />
                </div>
                <div className="infos-container">
                    <span className="infos-container-title metas">Métas :</span>
                    <CustomTag className={subscriptionMetas ? "active" : "deactivated"} value={subscriptionMetas ? "Oui" : "Non"} />
                </div>
            </div> */}
            <div className="infos-content-wrapper">
                <div className="infos-title-wrapper globe justify-between">
                    <p>OVH</p>
                    <button className="button-large" onClick={() => setShowMappingModal(true)}>
                        <PencilIcon size={16} weight="bold" /> Gestion des NDD
                    </button>
                </div>
                <div className="infos-container">
                    <span className="infos-container-title gear-six">Gestion du NDD :</span>
                    {contact.ovh?.domains?.length > 0 ? (
                        <CustomTag
                            className={contact.ovh.domains.every((domain) => domain.isOwnedByAltelis) ? "" : "deactivated"}
                            value={contact.ovh.domains.every((domain) => domain.isOwnedByAltelis) ? "Altelis" : "Externe"}
                        />
                    ) : (
                        <CustomTag className="deactivated" value="Non renseigné" />
                    )}
                </div>
                <div className="infos-container">
                    <span className="infos-container-title euro">Gestion du paiement du NDD :</span>
                    {contact.ovh?.domains?.length > 0 ? (
                        <CustomTag
                            className={contact.ovh.domains.every((domain) => domain.contactBilling === "gp128404-ovh") ? "" : "unpaid"}
                            value={contact.ovh.domains.every((domain) => domain.contactBilling === "gp128404-ovh") ? "Altelis" : "Client"}
                        />
                    ) : (
                        <CustomTag className="deactivated" value="Non renseigné" />
                    )}
                </div>
                <div className="infos-container">
                    <span className="infos-container-title cms">Domaines OVH :</span>
                    {contact.ovh?.domains?.length > 0 ? (
                        contact.ovh.domains.map((domain, index) => <CustomTag key={index} className={index === 0 ? "purple" : ""} value={domain.domainName || "Non renseigné"} />)
                    ) : (
                        <CustomTag className="deactivated" value="Non renseigné" />
                    )}
                </div>
            </div>
            <div className="infos-content-wrapper">
                <div className="infos-title-wrapper envelope">
                    <p>Gestion des mails</p>
                </div>
                <div className="infos-container">
                    <span className="infos-container-title messagerie">Messagerie :</span>
                    {contact.ovh?.emails?.length > 0 ? (
                        [...new Set(contact.ovh.emails.map((email) => email.type))].map((type, index) => (
                            <CustomTag
                                key={index}
                                value={type || "Non renseigné"}
                                className={type === "exchange" ? "purple uppercase" : type === "pro" ? "blue uppercase" : type === "mxplan" ? "pink uppercase" : "active uppercase"}
                            />
                        ))
                    ) : (
                        <CustomTag className="deactivated" value="Non renseigné" />
                    )}
                </div>
                {contact.ovh?.emails?.length > 0 && (
                    <div className="infos-container">
                        <span className="infos-container-title adresse-mail">Adresses mails gérées :</span>
                        {contact.ovh.emails.map((email, index) => (
                            <CustomTag
                                key={index}
                                value={email.email || "Non renseigné"}
                                className={email.type === "exchange" ? "purple" : email.type === "pro" ? "blue" : email.type === "mxplan" ? "pink" : "active"}
                            />
                        ))}
                    </div>
                )}
            </div>

            <CustomModal title="Gestion des domaines OVH" show={showMappingModal} setShow={setShowMappingModal}>
                <div className="custom__modal-group">
                    <label className="globe">Ajouter un domaine</label>
                    <div className="custom__modal-group">
                        <CustomSelect
                            value={selectedDomains}
                            onChange={setSelectedDomains}
                            options={availableDomains}
                            placeholder="Rechercher un domaine..."
                            isClearable
                            isSearchable
                            isMulti
                            className="modal-select"
                            menuPlacement="bottom"
                            maxMenuHeight={200}
                        />
                    </div>
                </div>

                {contact.ovh?.domains?.length > 0 && (
                    <div className="custom__modal-group">
                        <label className="name">Domaines mappés</label>
                        <div className="modal__selected-children overflow">
                            {contact.ovh.domains.map((domain, index) => (
                                <div key={index} className="modal__selected-child w-full">
                                    <CustomTag value={`${domain.domainName}`} className={index === 0 ? "purple" : ""} />
                                    <button onClick={() => unmapDomain(domain.domainName)} disabled={mappingLoading} className="modal__remove-child-btn" title="Supprimer ce domaine">
                                        <XIcon size={12} weight="bold" />
                                    </button>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                {availableDomains.length === 0 && (
                    <div className="custom__modal-group">
                        <CustomTag value="Aucun domaine OVH disponible" className="deactivated" />
                    </div>
                )}
                <div className="modal-buttons">
                    <button onClick={() => setShowMappingModal(false)} className="button-large cancel-button" disabled={mappingLoading}>
                        Annuler
                    </button>
                    <button onClick={mapDomains} disabled={!selectedDomains || selectedDomains.length === 0 || mappingLoading} className="button-large green-button">
                        {mappingLoading ? <CircularProgress size={16} className="modal-progress" /> : <PlusIcon size={16} />}
                        {mappingLoading ? "Mapping en cours..." : `Mapper ${selectedDomains.length > 0 ? selectedDomains.length : ""} domaine(s)`}
                    </button>
                </div>
            </CustomModal>
        </div>
    );
};

export default CustomerInfo;
